<mwe-basic-card headingNodeType="h4">
  <div class="row">
    <div class="col-12 col-md-6">
      <h4 class="h5 mb-3">
        <i class="fas fa-box-circle-check mr-1" aria-hidden="true"></i>
        <span translate="routerCard.title"></span>
      </h4>
      <p class="mb-1" data-test="router-name">
        <strong><span translate="routerCard.name"></span>: </strong>{{ routerName() }}
      </p>
      <p class="mb-0" data-test="router-price">
        <strong><span translate="routerCard.price"></span>: </strong>{{ routerPrice() }}
      </p>
    </div>
    <div class="col-12 col-md-6 d-flex gap-2 justify-content-center align-items-center">
      <div class="w-md-100">
        <img src="/assets/img/mvno/G5B2front.png" alt="5G Router Vorderseite" class="img-fluid" />
      </div>
      <div class="w-md-100">
        <img src="/assets/img/mvno/G5B2back.png" alt="5G Router Rückseite" class="img-fluid" />
      </div>
    </div>
  </div>
</mwe-basic-card>
